export default __webpack_public_path__ + "static/media/loader_etc.c1ce1bd6.gif";